<template>
    <div>
        <p><a class="button add-button" @click="addCustomTag">Add Another</a></p>
        <div v-for="(customTag, index) in custom.custom" :key="index" class="field-container">
            <div class="field third">
                <label for="" class="label">Label</label>    
                <input type="text" class="input" :value="customTag.label" @input="updateCustomTagLabel($event, index)">
            </div> 
            <div class="field third">
                <label for="" class="label">Text</label>    
                <input type="text" class="input" :value="customTag.value" @input="updateCustomTagValue($event, index)">
            </div>
            <a class="button is-danger remove-button" @click="removeCustomTag(index)">Remove</a>
        </div>
    </div>        
</template>

<script>
import { mapState } from 'vuex';

export default {  
    props: {
        
    },
    components: {

    },
    data: function() {
        return {
            
        };
    },
    computed: {
        ...mapState({
            custom: state => state.custom,
        }),
    },
    methods: {           
        addCustomTag() {
            this.$store.commit('custom/addBlankCustomTag');
        },
        updateCustomTagLabel(e, index) {
            this.$store.commit('custom/setCustomTagLabel', {
                value: e.target.value,
                index
            });
        },
        updateCustomTagValue(e, index) {
            this.$store.commit('custom/setCustomTagValue', {
                value: e.target.value,
                index
            });
        },
        removeCustomTag(index) {
            this.$store.commit('custom/removeCustomTag', index);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .add-button {
        margin-bottom: 0.5rem;
    }
    .remove-button {
        margin-top: auto;
        margin-bottom: 0.75rem;
    }
</style>
